// Affiche du HTML compilé par le serveur à partir de notre Markdown (contenu de confiance :
// c'est notre propre dépôt curriculum, converti sans HTML brut).
export function Html({ html, className = '', enLigne = false }: { html: string; className?: string; enLigne?: boolean }) {
  // `enLigne` pour un fragment rendu sans <p> autour (versHtmlEnLigne) : un <div> le sortirait
  // du paragraphe qui l'accueille.
  if (enLigne) return <span className={className} dangerouslySetInnerHTML={{ __html: html }} />;
  return <div className={`contenu-html ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}
